import {fetch} from '../../../utils/fetch'
import userService from '../../../services/user-service'
import update from 'react-addons-update'
import {ruleServerUrl} from 'configs/rule-server'
import _ from 'lodash'

const initialState = {
  isLoggedIn: false
}
const LOG_IN_COMPLETE = 'LOG_IN_COMPLETE'
const LOG_IN_FAILED = 'LOG_IN_FAILED'
const LOG_OUT_COMPLETE = 'LOG_OUT_COMPLETE'

export function login(credentials) {
  return (dispatch) => {
    return userService.getCurrentUser()
      .then((user) => {
        dispatch({
          type: LOG_IN_COMPLETE,
          data: {
            user: user
          }
        })
      }).catch((error) => {
        return dispatch({
          type: LOG_IN_FAILED,
          data: {
            error: error
          }
        })
      })
  }
}

function isDemoUser(user) {
  return _.endsWith(_.get(user, 'tenant.esKey'), '_demo')
}

export function loginReducer(state = initialState, action) {
  switch (action.type) {
    case LOG_IN_COMPLETE:
      let user = action.data.user
      return update(state, {
        isLoggedIn: {$set: true},
        isDemoUser: {$set: isDemoUser(user)},
        user: {$set: user},
        error: {$set: undefined}
      })
    case LOG_OUT_COMPLETE:
      return update(state, {
        isLoggedIn: {$set: false},
        isDemoUser: {$set: false},
        user: {$set: undefined},
        error: {$set: undefined}
      })
    case LOG_IN_FAILED:
      return update(state, {
        isLoggedIn: {$set: false},
        isDemoUser: {$set: false},
        user: {$set: undefined},
        error: {$set: action.data.error}
      })
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/routes/Login/modules/login.js